export default __webpack_public_path__ + "static/media/r930.8914bc28.PNG";